import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { tutorialsApi, type TutorialCategoryGroup, type TutorialDetails } from 'api/tutorialsApi';
import { ApiError } from 'utils/unwrapResponse';

export const TUTORIALS_QUERY_KEY = ['admin-tutorials'] as const;

export const useTutorials = () =>
  useQuery<TutorialCategoryGroup[]>({
    queryKey: TUTORIALS_QUERY_KEY,
    queryFn: tutorialsApi.list,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: (failureCount, error) =>
      !(error instanceof ApiError && (error.status === 403 || error.status === 503)) && failureCount < 2,
  });

// Refetches on error too: a 404 means someone deleted the video, and its row must go
export const useUpdateTutorial = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, details }: { id: string; details: TutorialDetails }) => tutorialsApi.update(id, details),
    onSettled: () => queryClient.invalidateQueries({ queryKey: TUTORIALS_QUERY_KEY }),
  });
};
